import { END_SESSION } from '../actions/authActions';
import { UNSUBSCRIBE_CURRENT_ACCOUNT } from '../actions/currentAccountActions';
import { ADD_AUDIT_EVENT, SET_AUDIT_ORDER, SET_AUDIT_ORDERS } from '../actions/auditOrderActions';

const DEFAULT_STATE = {
  items: [],
  lastUpdated: null,
};

let auditOrderExists, items;

export default function auditOrdersReducer(state = DEFAULT_STATE, { type, payload }) {
  switch (type) {
    case END_SESSION:
    case UNSUBSCRIBE_CURRENT_ACCOUNT:
      return DEFAULT_STATE;
    case SET_AUDIT_ORDERS:
      return {
        ...state,
        items: payload,
        lastUpdated: new Date().toISOString(),
      };
    case SET_AUDIT_ORDER:
      auditOrderExists = !!getAuditOrder(state, payload.id);
      items = auditOrderExists
        ? state.items.map((item) => {
            return item.id === payload.id ? payload : item;
          })
        : [...state.items, payload];
      return {
        ...state,
        items,
        lastUpdated: new Date().toISOString(),
      };
    case ADD_AUDIT_EVENT:
      auditOrderExists = !!getAuditOrder(state, payload.auditOrderId);
      items = auditOrderExists
        ? state.items.map((item) => {
            return item.id === payload.auditOrderId
              ? {
                  ...item,
                  events: { ...item.events, [payload.id]: payload },
                }
              : item;
          })
        : [...state.items, payload];
      return {
        ...state,
        items,
        lastUpdated: new Date().toISOString(),
      };
    default:
      return state;
  }
}

export const getAuditOrders = (state) => {
  return state.items;
};

export const getAuditOrder = (state, id) => {
  return state.items.find((item) => item.id === id);
};

export const auditOrdersLastUpdated = (state) => {
  return state.lastUpdated;
};
